import { UserRole, type User } from '../types';
import {
  APPROVAL_WORKBENCH_ROLES,
  BUYER_WORKBENCH_ROLES,
  PLATFORM_WORKBENCH_ROLES,
} from './workbenchView';
import { detectMobileOrMiniProgram } from './supplierView';
import { isYanxuanEnabled } from '../config/yanxuanFeature';

/** 登录后或已登录会话恢复时，后台预拉取目标工作台 chunk */
export function prefetchWorkbenchByRole(role?: User['role']): void {
  if (!role) return;
  const mobile = detectMobileOrMiniProgram();

  if (BUYER_WORKBENCH_ROLES.includes(role as UserRole)) {
    void import('../pages/Buyer');
    if (mobile) void import('../pages/BuyerH5');
    return;
  }

  if (APPROVAL_WORKBENCH_ROLES.includes(role as UserRole)) {
    void import('../pages/Approval');
    if (mobile) void import('../pages/ApprovalH5');
    return;
  }

  if (role === UserRole.YANXUAN_ADMIN) {
    if (isYanxuanEnabled()) void import('../pages/YanxuanPlatform');
    return;
  }

  if (PLATFORM_WORKBENCH_ROLES.includes(role as UserRole)) {
    void import('../pages/Platform');
    if (mobile) void import('../pages/PlatformH5');
    // 系统管理员进平台管理端，不预拉严选配货工作台
    return;
  }

  if (role === UserRole.SUPPLIER) {
    void import('../pages/SupplierWorkbenchV2');
    if (mobile) void import('../pages/SupplierH5');
    return;
  }

  if (role === UserRole.COMPANY_ADMIN) {
    void import('../pages/Settings/CompanySettings');
  }
}

/** 首屏常见入口页预加载（与 main.js 并行） */
export function prefetchPublicEntryPages(): void {
  void import('../pages/Portal');
  void import('../pages/Login');
}

/** 采购工作台默认 Tab 子模块预加载 */
export function prefetchBuyerDefaultPanes(): void {
  // 严选关闭时 1.0 直采用户不多下载严选首页 chunk
  if (isYanxuanEnabled()) void import('../pages/YanxuanBuyerHome');
  void import('../pages/Buyer/components/ProductList');
}
